import { Responsive } from "../../common/responsive";
import { NavBarLarge } from "./large";
import { NavBarSmall } from "./small";

export function NavBar() {
  return <Responsive Large={NavBarLarge} Small={NavBarSmall} />;
}
